<template>
    <div id="gender-form-group" style="margin-bottom: 16px;" class="alt-form-group select-form-group form-group is_required" data-id="gender"><label
         style="margin-bottom: 5px;"   for="gender">Gender </label>
        <div class="alt-form-field-group"><input type="text" id="gender" name="gender" class="form-control" value=""
                style="position: absolute;height: 0;top: 10px;opacity: 0;">
            <div class="master-template__select-option custom_option_pt" id="group-gender">
                <div class="pt_option_select"><button type="button" class="gender-button active" data-value="Male"
                        data-group="gender" fdprocessedid="15ceg">Male</button><button type="button"
                        class="gender-button " data-value="Female" data-group="gender"
                        fdprocessedid="att1e">Female</button></div>
            </div>
            <input type="hidden" name="gender" class="custom_gender" id="gender" value="Male">
        </div>
    </div>
</template>
<script setup>
onMounted(() => {
    document.querySelectorAll("#group-gender .gender-button").forEach(function (button) {
    button.addEventListener("click", function () {
        document.querySelectorAll("#group-gender .gender-button").forEach(function (btn) {
            btn.classList.remove("active");
        });

        this.classList.add("active");

        document.querySelector(".custom_gender").value = this.getAttribute("data-value");
    });
});
})

</script>
<style lang="scss">
.master-template__select-option.custom_option_pt .pt_option_select {
    display: flex;
    gap: 15px;
    background: #c60c46;
    width: max-content;
    padding: 8px;
    border-radius: 5px;
}

.master-template__select-option.custom_option_pt .pt_option_select button {
    background: transparent;
    border: none;
    padding: 1px 20px;
    color: #FFFFFF;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
}

.master-template__select-option.custom_option_pt .pt_option_select button.active {
    background: #ffffff;
    color: #000000;
}

.social-account-options.pt_custom_checkbox {
    text-align: left;
}

.social-account-options.pt_custom_checkbox label {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
}
</style>